export function GenericInfoField({ id, spanSize, label, value }) {
  return (
    <>
      <div key={id} className={`${spanSize} gap-3`}>
        <label className="font-semibold text-sm">{label}:</label>
        <p className="border border-gray h-[43px] text-gray2 mb-3 p-2 overflow-hidden rounded w-full bg-[#ffffff]">{value}</p>
      </div>
    </>
  )
}